/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".code[_ngcontent-%COMP%]{height:40px;padding-top:20px}.value[_ngcontent-%COMP%]{font-weight:700}"];
export { styles as styles };
